/* CofCof — galeria acessivel da pagina de produto.
 *
 * C11-09 — este arquivo e declarado pelo PROPRIO template, ao lado da galeria,
 * e nao por lista branca no layout. A lista branca foi a causa do pior defeito
 * desta tarefa: a home renderizou a caixa de compra sem o JS dela por meses, e
 * o cliente comprava a variante errada pelo preco errado.
 *
 * Declarado pelo template, o script pode ser emitido duas vezes se a galeria
 * aparecer duas vezes na mesma pagina: o navegador baixa uma vez e EXECUTA
 * duas. Sem a marca abaixo, cada miniatura ganharia dois listeners de clique, e
 * a classe is-active alternaria duas vezes por toque.
 */
(function () {
  'use strict';

  if (document.documentElement.dataset.cofcofGaleriaPronta === '1') return;

  var mainImage = document.getElementById('cofcof-product-main-image');
  var thumbnails = Array.prototype.slice.call(document.querySelectorAll('[data-cof-product-thumb]'));
  if (!mainImage || !thumbnails.length) return;

  document.documentElement.dataset.cofcofGaleriaPronta = '1';

  /* C11-09 rodada 1 — a troca de imagem acontecia em SILÊNCIO.
   *
   * Medido: nenhuma região viva na coluna de mídia. Quem usa leitor de tela
   * aperta Enter em "Ver verso da embalagem", o `src` e o `alt` mudam, e nada é
   * anunciado — o `alt` de uma imagem já pintada não é relido. É a mesma classe
   * de defeito que o preço resolveu na rodada 1 com `role="status"`; a galeria
   * nunca tinha sido auditada.
   *
   * A região é criada pelo JS e não pelo Liquid de propósito: sem script não há
   * troca de imagem, então não há o que anunciar. Um `aria-live` vazio no HTML
   * seria uma promessa que a página não cumpre com o JS fora do ar.
   *
   * `polite`, e não `assertive`: a pessoa acabou de pedir a troca; interromper
   * o que o leitor está falando para confirmar o que ela mesma fez é ruído. */
  var vivo = document.createElement('p');
  vivo.className = 'cofcof-sr-only';
  vivo.setAttribute('role', 'status');
  vivo.setAttribute('aria-live', 'polite');
  mainImage.parentNode.appendChild(vivo);

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {
      var source = thumbnail.getAttribute('data-src');
      if (!source) return;

      /* Tirar `srcset`/`sizes` e apontar para o arquivo de 1200px faz o telefone
       * baixar 1200 numa caixa de 225. Nenhum produto de hoje passa por aqui —
       * os sete cafés usam a embalagem oficial, que não tem `srcset` — mas o
       * ramo `product.featured_media` existe e um produto futuro cairá nele.
       * `sizes` é o que ensina o navegador a escolher; ele fica. */
      if (mainImage.srcset) {
        mainImage.srcset = '';
      }
      var stage = mainImage.parentNode.querySelector('[data-cof-product-stage]');
      var showStage = !!stage && thumbnail.getAttribute('data-presentation') === 'mockup';
      if (stage) { stage.hidden = !showStage; stage.dataset.face = thumbnail.getAttribute('data-stage-face') || 'front'; }
      mainImage.hidden = showStage;
      if (!showStage) mainImage.src = source;
      mainImage.alt = thumbnail.getAttribute('data-alt') || '';
      vivo.textContent = mainImage.alt;

      thumbnails.forEach(function (item) {
        var selected = item === thumbnail;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-current', selected ? 'true' : 'false');
      });
    });
  });
}());
// COFCOF product presentation 2026-10-21 v1.
